import * as y from 'yup'

/** @param {import("react-i18next").TFunction} t */
export const generateSchema = (t) => {
  return {
    goodsGroup: y.object({
      code: y
        .string()
        .required(t('Required'))
        .max(100, 'Mã nhóm hàng hóa, dịch vụ tối đa 100 ký tự'),
      name: y
        .string()
        .required(t('Required'))
        .max(300, 'Tên nhóm hàng hóa, dịch vụ tối đa 300 ký tự'),
    }),
    partner: y.object({
      namePartner: y
        .string()
        .required(t('Required'))
        .max(255, 'Mã nhóm hàng hóa, dịch vụ tối đa 255 ký tự'),
      userNameRabbitmq: y
        .string()
        .required(t('Required'))
        .max(255, 'Tên tài khoản tối đa 255 ký tự'),
      vhostRabbitmq: y
        .string()
        .required(t('Required'))
        .max(255, 'Tên tài khoản tối đa 255 ký tự'),
      technicalContactFullName: y
        .string()
        .max(255, 'Tên tài khoản tối đa 255 ký tự'),
      technicalContactEmail: y
        .string()
        .max(255, 'Tên tài khoản tối đa 255 ký tự'),
      technicalContactPhone: y
        .string()
        .max(12, 'Tên tài khoản tối đa 12 ký tự'),
      service: y.string().max(255, 'Tên dịch vụ tối đa 255 ký tự'),
      sizingDescription: y.string().max(500, 'Mô tả dịch vụ tối đa 500 ký tự'),
      transactionVolumeByPeriodQuarter: y
        .string()
        .max(255, 'Dự kiến lượng giao dịch phát sinh tối đa 255 ký tự'),
      peakDayTransactions: y
        .number()
        .min(1, 'Giá trị tối thiểu là 1')
        .max(10000000000, 'Giá trị tối đa là 10.000.000.000'),
      normalDayTransactions: y
        .number()
        .min(1, 'Giá trị tối thiểu là 1')
        .max(10000000000, 'Giá trị tối đa là 10.000.000.000'),
    }),
  }
}
